// extracted by mini-css-extract-plugin
export default {"rating":"ZQ-z","numberOfStars":"_Q-z","count":"aR-z","barGraphSpacing":"bR-z","barGraph":"cR-z"};